import {Loadable} from 'app/components/general/lazyLoader';
import {DetailLoadingPage} from 'app/general/loading/DetailLoadingPage';

import type {FormItemProps} from '../BaseFormField';
import type {Props} from './types';
import type {SweetError} from 'app/utils/errors';

export const LoadableEditableAvatar = Loadable<
  SweetError,
  Props & Omit<FormItemProps, 'children'>
>({
  loader: () => import(/* webpackChunkName: "editable-avatar" */ '.'),
  //eslint-disable-next-line react/display-name
  LoadingComponent: DetailLoadingPage,
});
